import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import createComplectation from '../../../api/cars/createComplectation';
import Form from '../../../components/Form/Form';
import Header from '../../../components/Header/Header';
import styles from '../../../components/Form/form.module.css';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import Checkbox from '../../../components/Inputs/Checkbox/Checkbox';
import icon from '../../../brand/generated/sidebar/cars.svg';
import { EQUIPMENT_VALUE_PLACEHOLDER, SAFETY_VALUE_PLACEHOLDER } from './optionPlaceholders';

const formStyles = {
  complectation: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' },
};

const CarComplectationsCreate = () => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const makeKey = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

  const [complectation, setComplectation] = useState([
    { type: 'input', value: undefined, label: 'ID', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ID', inputType: 'number' },
    { type: 'input', value: undefined, label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ' },
    { type: 'selectEngine', value: 1 },
    { type: 'selectCarcase', value: 1 },
    { type: 'selectWd', value: 2 },
    { type: 'input', label: 'ÐÐ±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', value: undefined },
    { type: 'input', label: 'Ð.Ð¡.', value: undefined },
    { type: 'input', label: 'ÐÐ¾ÑÐ¾Ð±ÐºÐ° Ð¿ÐµÑÐµÐ´Ð°Ñ', value: undefined },
    { type: 'input', label: 'ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¼ÐµÑÑ', value: undefined },
    { type: 'input', label: 'ÐÐ¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ', value: undefined },
  ]);
  const [restyling, setRestyling] = useState(false);
  const [equipments, setEquipments] = useState([{ key: makeKey(), title: '', subtitle: '' }]);
  const [safety, setSafety] = useState([{ key: makeKey(), title: '', subtitle: '' }]);

  // ÐÐ¿ÑÐ¸Ñ â Ð¿Ð°ÑÐ° Â«Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ â Ð·Ð½Ð°ÑÐµÐ½Ð¸ÐµÂ» (Â«ÐÐ°ÑÑÐ¸ÐºÐ¸ Ð¿Ð°ÑÐºÐ¾Ð²ÐºÐ¸Â» â Â«ÐÐ°Ð´Ð½Ð¸ÐµÂ»): ÑÐ°Ðº ÐµÑ
  // Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÐ° Halyk Market. ÐÑÑÑÐ¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð½Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼.
  const optionRows = (rows) =>
    rows.map(({ title, subtitle }) => ({ title, subtitle: (subtitle || '').trim() || undefined }));

  const createComplectationCar = () => {
    createComplectation({
      title: complectation[1].value,
      containerId: searchParams.get('id'),
      engineId: complectation[2].value,
      complectation_safely: optionRows(safety),
      complectation_equipment: optionRows(equipments),
      carcaseId: complectation[3].value,
      wdId: complectation[4].value,
      engine_volume: complectation[5].value,
      power_value: complectation[6].value,
      transmission: complectation[7].value,
      seats: complectation[8].value,
      generation: complectation[9].value,
      restyling: restyling,
    }).then(() => navigate('/cars/complectations'));
  };

  return (
    <>
      <Header title={'ÐÐ¾Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ'} icon={icon} />
      <div style={{ paddingBottom: '20px' }}>
        <Form
          inputs={complectation}
          title={'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸'}
          grid={formStyles.complectation}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
          showBtn={false}
          handlerSetState={setComplectation}
          handleSubmit={createComplectationCar}
          border
          footer={
            <Checkbox
              label="ÐÑÐ¸Ð·Ð½Ð°Ðº ÑÐµÑÑÐ°Ð¹Ð»Ð¸Ð½Ð³Ð° Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ"
              id="restyling"
              value={restyling}
              onChange={() => setRestyling(!restyling)}
              style={{ marginTop: 20, marginBottom: 20, marginLeft: 20 }}
            />
          }
        />

        <div className={styles.borderWrapper}>
          <h1>ÐÐ¾Ð¼ÑÐ¾ÑÑ Ð¸ ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ</h1>
          <br />
          {equipments.map((item, index) => (
            <div
              key={item.key}
              style={{ marginBottom: 15, display: 'grid', gridTemplateColumns: '1fr 2fr 55px', gap: 10, alignItems: 'end' }}
            >
              <Input
                label={'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ'}
                placeholder={'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ'}
                value={item.title}
                onChange={(e) => {
                  equipments[index].title = e.target.value;
                  setEquipments([...equipments]);
                }}
              />
              <Input
                label={'ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ'}
                placeholder={EQUIPMENT_VALUE_PLACEHOLDER}
                value={item.subtitle}
                onChange={(e) => {
                  equipments[index].subtitle = e.target.value;
                  setEquipments([...equipments]);
                }}
              />
              {/* <Button
                style={{ marginLeft: 0, cursor: 'pointer' }}
                text={'X'}
                onClick={() => {
                  if (equipments.length === 1) {
                    setEquipments([{ key: makeKey(), title: '' }]);
                    return;
                  }
                  setEquipments(equipments.filter((i) => i.key !== item.key));
                }}
              /> */}
            </div>
          ))}
          <Button
            onClick={() => {
              equipments.push({ key: makeKey(), title: '', subtitle: '' });
              setEquipments([...equipments]);
            }}
            style={{
              marginTop: 15,
              marginBottom: 15,
            }}
            text={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ'}
            fill
          />
          <h1>ÐÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÑ</h1>
          {safety.map((item, index) => (
            <div
              key={item.key}
              style={{ marginBottom: 15, display: 'grid', gridTemplateColumns: '1fr 2fr 55px', gap: 10, alignItems: 'end' }}
            >
              <Input
                label={'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ'}
                placeholder={'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ'}
                value={item.title}
                onChange={(e) => {
                  safety[index].title = e.target.value;
                  setSafety([...safety]);
                }}
              />
              <Input
                label={'ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ'}
                placeholder={SAFETY_VALUE_PLACEHOLDER}
                value={item.subtitle}
                onChange={(e) => {
                  safety[index].subtitle = e.target.value;
                  setSafety([...safety]);
                }}
              />
              {/* <Button
                style={{ marginLeft: 0, cursor: 'pointer' }}
                text={'X'}
                onClick={() => {
                  if (safety.length === 1) {
                    setSafety([{ key: makeKey(), title: '' }]);
                    return;
                  }
                  setSafety(safety.filter((i) => i.key !== item.key));
                }}
              /> */}
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={() => {
                safety.push({ key: makeKey(), title: '', subtitle: '' });
                setSafety([...safety]);
              }}
              style={{
                marginTop: 15,
                marginBottom: 15,
              }}
              text={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ'}
              fill
            />
            <Button
              onClick={() => createComplectationCar()}
              style={{
                marginTop: 15,
                marginBottom: 15,
              }}
              text={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
              fill
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CarComplectationsCreate;
